export class PaymentDocuments 
{
    documentId: string;
    amount: string;
    reason: string
}
